// Import dependencies
import React from 'react';
import axios from 'axios';
import cookie from 'js-cookie';
import { tokenize } from '../../../../../helper';
import { ExportToCsv } from 'export-to-csv';
import moment from 'moment'
import Select from 'react-select'
// Import styling
import './LivestreamAnalyticsPage.css';
import AdminNavbar from '../../../../reusables/adminNavbar';

// Import config
import config from '../../../../../configs/config.json';
const API_URL = config.API_URL;
const ADMIN_API_URL = API_URL + '/admin';
const SETTINGS_URL = ADMIN_API_URL + '/settings';

class LivestreamAnalyticsPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sortKey: 'time_asc',
            options: [
            ],
            selectedOption: null,
            selectedResults: null,
        }
    }

    componentDidMount() {
        // When the component (screen) mounts, check cooke if user is already logged in

        var token = cookie.get('token');
        var user_type = cookie.get('user-type');

        if (token) {
            if (user_type === 'admin') {
                // Admin authorized, query the back-end for the login history
                this.fetchVideoViews();

            } else {
                // Not authorized, re-direct to admin log in page
                window.location.href = '/admin';
            }
        } else {
            // No token found, re-direct them to admin log in page
            window.location.href = '/admin'
        }
        this.getLivestreamViews()
    }

    truncate = (input) => input.length > 30 ? `${input.substring(0, 30)}...` : input;

    prettyDate = (date) => {
        return moment(date).format('MMMM Do YYYY, h:mm:ss a');
    }

    getLivestreamViews = () => {
        axios.get(`${SETTINGS_URL}/analytics/livestream`, tokenize())
            .then(response => {
                if (response.data.success) {
                    // add to options
                    let arr = []
                    response.data.result.map(i => {
                        const date = i['date'].split('-');
                        const dateObj = new Date(date[2], date[1] - 1, date[0]);
                        const newDate = moment(dateObj).format('MMMM Do YYYY');

                        arr.push({ value: `${date[2]}-${date[1]}-${date[0]}`, label: newDate.toString() })
                    })
                    this.setState({ options: arr })
                    console.log(response.data)
                } else {
                    console.log("There was an error")
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    sortFunction = (a, b) => {
        return
    }

    sortData = () => {
        if (!this.state.selectedResults) return

        const key = this.state.sortKey;

        let sorted;

        if (key === 'time_asc') {
            sorted = this.state.selectedResults.sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
        } else if (key === 'time_desc') {
            sorted = this.state.selectedResults.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
        } else if (key === 'name_desc') {
            sorted = this.state.selectedResults.sort((a, b) => {
                if (a.name < b.name) { return -1; }
                if (a.name > b.name) { return 1; }
                return 0;
            })
        } else if (key === 'name_asc') {
            sorted = this.state.selectedResults.sort((b, a) => {
                if (a.name < b.name) { return -1; }
                if (a.name > b.name) { return 1; }
                return 0;
            })
        } else if (key === 'email_desc') {
            sorted = this.state.selectedResults.sort((a, b) => {
                if (a.email < b.email) { return -1; }
                if (a.email > b.email) { return 1; }
                return 0;
            })
        } else if (key === 'email_asc') {
            sorted = this.state.selectedResults.sort((b, a) => {
                if (a.name < b.name) { return -1; }
                if (a.name > b.name) { return 1; }
                return 0;
            })
        }

        this.setState({ selectedResults: sorted })
    }

    getLivestreamViewsByDate = () => {
        axios.get(`${SETTINGS_URL}/analytics/livestream-date?date=${this.state.selectedOption.value}%`, tokenize())
            .then(response => {
                if (response.data.success) {
                    response.data.result.map((date, index) => {
                        response.data.result[index].joined = this.prettyDate(response.data.result[index].joined);
                    })
                    this.setState({ selectedResults: response.data.result });
                } else {
                    this.setState({ selectedResults: null })
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    fetchVideoViews = () => {
        axios.get(`${SETTINGS_URL}/analytics?sort=${this.state.sortKey}`, tokenize())
            .then(response => {
                var total_partial = 0;
                var total_full = 0;
                response.data.newResult.map((video) => {
                    total_partial = total_partial + video.partial_views
                    total_full = total_full + video.full_views
                })
                this.setState({
                    videos: response.data.newResult, stats: {
                        total_full: total_full,
                        total_partial: total_partial - total_full
                    }
                });
            })
            .catch(error => {
                console.log(error);
            })
    }

    exportCSV = () => {
        if (this.state.selectedResults) {
            const options = {
                filename: this.state.selectedOption.value,
                fieldSeparator: ',',
                quoteStrings: '"',
                decimalSeparator: '.',
                showLabels: true,
                showTitle: false,
                title: 'views',
                useTextFile: false,
                useBom: true,
                useKeysAsHeaders: true,
                // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
            };
            const csvExporter = new ExportToCsv(options);
            csvExporter.generateCsv(this.state.selectedResults);
        } else {
            alert("Cannot generate csv from empty results.")
        }
    }

    handleSortRequest = (type) => {
        console.log('handleSortRequest(): ', type);
        switch (type) {
            case 'name':
                (this.state.sortKey === 'name_desc') ? this.setState({ sortKey: 'name_asc' }) : this.setState({ sortKey: 'name_desc' });
                break;
            case 'email':
                (this.state.sortKey === 'email_desc') ? this.setState({ sortKey: 'email_asc' }) : this.setState({ sortKey: 'email_desc' });
                break;
            case 'time':
                (this.state.sortKey === 'time_desc') ? this.setState({ sortKey: 'time_asc' }) : this.setState({ sortKey: 'time_desc' });
                break;
            default:
                this.setState({ sortKey: 'URIDESC' });
        }

        setTimeout(() => {
            // sort data
            this.sortData()
        }, 100)
    }

    optionChange = (e) => {
        const selectedOption = this.state.options.find(option => option.value === e.value)
        this.setState({ selectedOption }, () => {
            this.getLivestreamViewsByDate()
        })
    }

    render() {
        return (<div>
            <AdminNavbar />

            <h1 className='pageTitle'>Livestream Analytics</h1>
            <p style={{ textAlign: 'center' }}>Select a date below to view all livestream views</p>

            <div style={{ padding: '10px 0 10px 0', display: 'flex' }}>
                <div style={{ width: '91%', paddingRight: '20px' }}>
                    <Select
                        options={this.state.options}
                        value={this.state.selectedOption}
                        onChange={e => this.optionChange(e)}
                    />
                </div>
                <button
                    type="button"
                    class="btn btn-success"
                    onClick={this.exportCSV}
                >
                    Export CSV
                </button>
            </div>

            <div className='loginStatsContainer'>
                <div>Total Views: {this.state.selectedResults ? this.state.selectedResults.length : 0}</div>
            </div>

            <table className='table-striped generalTable loginHistoryTable'>
                <thead>
                    <tr>
                        <td onClick={() => this.handleSortRequest('name')}>Name</td>
                        <td onClick={() => this.handleSortRequest('email')}>Email</td>
                        <td onClick={() => this.handleSortRequest('time')}>Time</td>
                    </tr>
                </thead>
                <tbody>
                    {
                        this.state.selectedResults && this.state.selectedResults.map((view, index) => {

                            return (<tr key={index}>
                                <td>{view.name}</td>
                                <td>{view.email}</td>
                                <td>{view.joined}</td>
                            </tr>)
                        })
                    }
                </tbody>
            </table>
        </div>)
    }
}

export default LivestreamAnalyticsPage;